"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3460],{

/***/ 85419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hw": function() { return /* binding */ Importance; },
/* harmony export */   "Vn": function() { return /* binding */ Safety; },
/* harmony export */   "eb": function() { return /* binding */ PassportandVisa; },
/* harmony export */   "iS": function() { return /* binding */ Insurance; },
/* harmony export */   "qX": function() { return /* binding */ Notice; },
/* harmony export */   "xU": function() { return /* binding */ Refer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _pages_pub_common_warning_pub__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10362);
/* harmony import */ var _COMPONENTS_common_commonUtil__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72425);
/* harmony import */ var _COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(17550);
/* harmony import */ var _COMPONENTS_product_pages_detailPackage_desktop_DetailLocalInformation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12740);
/* harmony import */ var _COMPONENTS_style_detailpackage_othernotes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98147);
/* harmony import */ var _COMPONENTS_style_detailpackage_productinformation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69338);
/* harmony import */ var _FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(32423);
/* harmony import */ var _FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36432);
/* harmony import */ var _FRAMEWORK_ui_desktop_editor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(58771);
/* harmony import */ var _FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47178);
/* harmony import */ var _FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(81499);
/* harmony import */ var _QUERIES_essential_contents_useContentsEmergency__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(82959);
/* harmony import */ var _QUERIES_prdt_event_useEventInsurance__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80313);
/* harmony import */ var _QUERIES_prdt_event_useEventNotice__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64767);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(67294);

















var NoticeComponent = function(param) {
    var evCd = param.evCd;
    var ref;
    var noticeFetch = (0,_QUERIES_prdt_event_useEventNotice__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(evCd);
    var notice = (ref = noticeFetch.data) === null || ref === void 0 ? void 0 : ref.body;
    var editorWrapRef = (0,react__WEBPACK_IMPORTED_MODULE_15__.useRef)(null);
    var targetRef = (0,react__WEBPACK_IMPORTED_MODULE_15__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_15__.useState)(false), showMore = ref1[0], setShowMore = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_15__.useState)(false), activeButton = ref2[0], setActiveButton = ref2[1];
    var elementHeight = showMore ? "auto" : "330px";
    var buttonText = showMore ? "닫기" : "더 보기";
    var handleButton = function() {
        setShowMore(!showMore);
        if (showMore) {
            var position = targetRef.current.getBoundingClientRect().top + window.scrollY - 160;
            window.scrollTo({
                top: position,
                behavior: "smooth"
            });
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_15__.useEffect)(function() {
        var ref;
        var ElementHight = (ref = editorWrapRef.current) === null || ref === void 0 ? void 0 : ref.clientHeight;
        if (ElementHight >= 240) {
            setActiveButton(true);
        } else {
            setActiveButton(false);
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: notice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                notice.inclInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_productinformation__WEBPACK_IMPORTED_MODULE_6__/* .SubTitleWrap */ .Ar, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_11__/* .SubTitle */ .DK, {
                                children: "포함사항"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .LineBox */ .es, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_editor__WEBPACK_IMPORTED_MODULE_9__/* .EditorBox */ .M, {
                                dangerouslySetInnerHTML: {
                                    __html: notice.inclInfo
                                }
                            })
                        })
                    ]
                }),
                notice.notinclInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_productinformation__WEBPACK_IMPORTED_MODULE_6__/* .SubTitleWrap */ .Ar, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_11__/* .SubTitle */ .DK, {
                                children: "불포함사항"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .LineBox */ .es, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_editor__WEBPACK_IMPORTED_MODULE_9__/* .EditorBox */ .M, {
                                dangerouslySetInnerHTML: {
                                    __html: notice.notinclInfo
                                }
                            })
                        })
                    ]
                }),
                (notice === null || notice === void 0 ? void 0 : notice.poliInfo) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .SubTitleWrap */ .Ar, {
                            ref: targetRef,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_11__/* .SubTitle */ .DK, {
                                children: "약관 / 취소수수료"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .LineBox */ .es, {
                            elementHeight: elementHeight,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_editor__WEBPACK_IMPORTED_MODULE_9__/* .EditorBox */ .M, {
                                ref: editorWrapRef,
                                dangerouslySetInnerHTML: {
                                    __html: notice === null || notice === void 0 ? void 0 : notice.poliInfo
                                }
                            })
                        }),
                        activeButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FRAMEWORK_ui_desktop_button__WEBPACK_IMPORTED_MODULE_8__/* .PlusMoreButton */ .sp, {
                            onClick: handleButton,
                            children: [
                                "약관 / 취소수수료 ",
                                buttonText
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/**
 * 포함/불포함/약관
 */ var Notice = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        logMsg: "ReferTabs Notice Error",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NoticeComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, props))
    });
};
var ReferComponent = function(param) {
    var evCd = param.evCd;
    var ref;
    var useNotice = (0,_QUERIES_prdt_event_useEventNotice__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(evCd);
    var notice = (ref = useNotice.data) === null || ref === void 0 ? void 0 : ref.body;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (notice === null || notice === void 0 ? void 0 : notice.miscInfo) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .SubTitleWrap */ .Ar, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_11__/* .SubTitle */ .DK, {
                            children: "참고/전달사항"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .LineBox */ .es, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_editor__WEBPACK_IMPORTED_MODULE_9__/* .EditorBox */ .M, {
                            dangerouslySetInnerHTML: {
                                __html: notice === null || notice === void 0 ? void 0 : notice.miscInfo
                            }
                        })
                    })
                ]
            }),
            (notice === null || notice === void 0 ? void 0 : notice.essenInfo) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .SubTitleWrap */ .Ar, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_11__/* .SubTitle */ .DK, {
                            children: "필수사항"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .LineBox */ .es, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_editor__WEBPACK_IMPORTED_MODULE_9__/* .EditorBox */ .M, {
                            dangerouslySetInnerHTML: {
                                __html: notice === null || notice === void 0 ? void 0 : notice.essenInfo
                            }
                        })
                    })
                ]
            })
        ]
    });
};
/**
 * 참고/전달사항
 */ var Refer = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        logMsg: "ReferTabs Refer Error",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReferComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, props))
    });
};
var ImportanceComponent = function(param) {
    var evCd = param.evCd;
    var ref, ref1;
    var goodsCd = evCd.split("-")[0];
    var useNotice = (0,_QUERIES_prdt_event_useEventNotice__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(evCd);
    var notice = (ref = useNotice.data) === null || ref === void 0 ? void 0 : ref.body;
    var useEmergency = (0,_QUERIES_essential_contents_useContentsEmergency__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)(goodsCd);
    var emergency = ((ref1 = useEmergency.data) === null || ref1 === void 0 ? void 0 : ref1.body) || [];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            (notice === null || notice === void 0 ? void 0 : notice.refeInfo) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .SubTitleWrap */ .Ar, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_11__/* .SubTitle */ .DK, {
                            children: "유의사항"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .LineBox */ .es, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_editor__WEBPACK_IMPORTED_MODULE_9__/* .EditorBox */ .M, {
                            dangerouslySetInnerHTML: {
                                __html: notice === null || notice === void 0 ? void 0 : notice.refeInfo
                            }
                        })
                    })
                ]
            }),
            emergency.length > 0 && emergency.map(function(item, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_15__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .SubTitleWrap */ .Ar, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_11__/* .SubTitle */ .DK, {
                                children: item.emerInfoTitle
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .LineBox */ .es, {
                            children: item.emerInfoConts && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_editor__WEBPACK_IMPORTED_MODULE_9__/* .EditorBox */ .M, {
                                dangerouslySetInnerHTML: {
                                    __html: item.emerInfoConts
                                }
                            })
                        })
                    ]
                }, index);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .SubTitleWrap */ .Ar, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_11__/* .SubTitle */ .DK, {
                    children: "주의사항"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .LineBox */ .es, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pages_pub_common_warning_pub__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
            })
        ]
    });
};
/**
 * 유의사항
 */ var Importance = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        logMsg: "ReferTabs Importance Error",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImportanceComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, props))
    });
};
// const TermsAndCancellationFeeComponent = ({evCd}: {evCd: string}) => {
// 	const useNotice = useEventNotice(evCd);
// 	const notice = useNotice.data?.body;
// 	return (
// 		<>
// 			{notice?.poliInfo && (
// 				<>
// 					<SubTitleWrap>
// 						<SubTitle>약관 / 취소수수료</SubTitle>
// 					</SubTitleWrap>
// 					<LineBox>
// 						<EditorBox dangerouslySetInnerHTML={{__html: notice?.poliInfo}} />
// 					</LineBox>
// 				</>
// 			)}
// 		</>
// 	);
// };
// /**
//  * 약관 / 취소수수료
//  */
// const TermsandCancellationFee = (props: {evCd: string}) => (
// 	<ErrorBoundary logMsg="ReferTabs TermsAndCancellationFee Error">
// 		<TermsAndCancellationFeeComponent {...props} />
// 	</ErrorBoundary>
// );
var PassportAndVisaComponent = function(param) {
    var evCd = param.evCd;
    var ref;
    var useNotice = (0,_QUERIES_prdt_event_useEventNotice__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP)(evCd);
    var notice = (ref = useNotice.data) === null || ref === void 0 ? void 0 : ref.body;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (notice === null || notice === void 0 ? void 0 : notice.passportInfo) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .SubTitleWrap */ .Ar, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_11__/* .SubTitle */ .DK, {
                        children: "여권/비자"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .LineBox */ .es, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_editor__WEBPACK_IMPORTED_MODULE_9__/* .EditorBox */ .M, {
                        dangerouslySetInnerHTML: {
                            __html: notice === null || notice === void 0 ? void 0 : notice.passportInfo
                        }
                    })
                })
            ]
        })
    });
};
/**
 * 여권/비자
 */ var PassportandVisa = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        logMsg: "ReferTabs PassportAndVisa Error",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PassportAndVisaComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, props))
    });
};
var SafetyComponent = function(param) {
    var _isButton = param.isButton, isButton = _isButton === void 0 ? true : _isButton, evCd = param.evCd;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .SubTitleWrap */ .Ar, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_11__/* .SubTitle */ .DK, {
                    children: "해외여행 안전정보"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .LineBox */ .es, {
                children: [
                    "외교부에서는 [여행경보제도]를 운영하고 있으며, 노랑풍선은 고객님의 안전한 해외여행을 위하여 이 정보를 제공하고 있습니다. 여행경보단계는 여행유의/자제/철수권고/금지 4단계로 구분되며,",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "단기적인 위험상황이 발생하는 경우 특별여행주의보/경보 2단계로 추가 구분하고 있습니다.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "외교부에서 국가별 상황에 따라 상시로 [여행경보제도]의 변경이 있을 수 있으므로, 당사에서 제공하는 안전 정보가 시점에 따라",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "다소 차이가 발생할 수 있사오니, 반드시 출국 전 여행목적지의(국가 및 지역,",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "https://www.0404.go.kr/ntnSafetyInfo/list",
                        target: "_blank",
                        rel: "noreferrer",
                        children: "www.0404.go.kr"
                    }),
                    ") 안전정보를 확인하시어",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "[외교부의 권고]를 따라 주시기 바랍니다.",
                    isButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_othernotes__WEBPACK_IMPORTED_MODULE_5__/* .InsuranceLink */ .k3, {
                        href: "https://pkg.ybtour.co.kr/cs/travelSafetyGuide.yb",
                        target: "_blank",
                        children: "여행 안전 유의사항 자세히 보기"
                    })
                ]
            }),
            evCd && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_product_pages_detailPackage_desktop_DetailLocalInformation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                evCd: evCd
            })
        ]
    });
};
/**
 * 해외여행 안전정보
 */ var Safety = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        logMsg: "ReferTabs Safety Error",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SafetyComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, props))
    });
};
var InsuranceComponent = function(param) {
    var evCd = param.evCd;
    var ref;
    // const goodsTp = evCd?.substring(0, 1);
    var useInsurance = (0,_QUERIES_prdt_event_useEventInsurance__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(evCd);
    var insurance = (ref = useInsurance.data) === null || ref === void 0 ? void 0 : ref.body;
    // const insuText = useMemo(() => (insurance?.insuType !== "S" ? "KB손해보험" : "삼성화재"), [insurance]);
    // const insuFileNm = useMemo(() => (insurance?.insuType !== "S" ? "KB" : "SAMSUNG_"), [insurance]);
    // const insuImg = useMemo(() => (insurance?.insuType !== "S" ? kbInsureImg : samsungInsureImg), [insurance]);
    // const ListContentRef = useRef([]);
    // const [expandedIndexes, setExpandedIndexes] = useState([]);
    // const handleToggle = (index: number) => {
    // 	setExpandedIndexes(prevIndexes =>
    // 		prevIndexes.includes(index) ? prevIndexes.filter(item => item !== index) : [...prevIndexes, index],
    // 	);
    // };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: (insurance === null || insurance === void 0 ? void 0 : insurance.atteInfo) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_othernotes__WEBPACK_IMPORTED_MODULE_5__/* .TitArea */ .jK, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_othernotes__WEBPACK_IMPORTED_MODULE_5__/* .TermsDownloadArea */ .vp, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_11__/* .SubTitle */ .DK, {
                            children: "보험"
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_layout__WEBPACK_IMPORTED_MODULE_10__/* .LineBox */ .es, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FRAMEWORK_ui_desktop_editor__WEBPACK_IMPORTED_MODULE_9__/* .EditorBox */ .M, {
                        dangerouslySetInnerHTML: {
                            __html: insurance.atteInfo
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_othernotes__WEBPACK_IMPORTED_MODULE_5__/* .InsuranceLink */ .k3, {
                    href: "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_7__/* ["default"].ENV_PACKAGE_URL */ .Z.ENV_PACKAGE_URL, "/common/travelerInsuInfo.yb"),
                    target: "_blank",
                    onClick: function(e) {
                        return (0,_COMPONENTS_common_commonUtil__WEBPACK_IMPORTED_MODULE_2__/* .onClickSSO */ .Zy)(e, "".concat(_FRAMEWORK_config_public__WEBPACK_IMPORTED_MODULE_7__/* ["default"].ENV_PACKAGE_URL */ .Z.ENV_PACKAGE_URL, "/common/travelerInsuInfo.yb"));
                    },
                    children: "여행자보험 보상한도, 보상기준, 보험약관 자세히 보기"
                })
            ]
        })
    });
};
/**
 * 여행자 보험
 */ var Insurance = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        logMsg: "ReferTabs Insurance Error",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InsuranceComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({}, props))
    });
};



/***/ }),

/***/ 93293:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Al": function() { return /* binding */ TourlistDestination; },
/* harmony export */   "BK": function() { return /* binding */ TourDetailTemplate; },
/* harmony export */   "aM": function() { return /* binding */ Enjoy; },
/* harmony export */   "jr": function() { return /* binding */ Food; },
/* harmony export */   "sE": function() { return /* binding */ Accommodation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20394);
/* harmony import */ var _hooks_common_useOverlay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91864);
/* harmony import */ var _COMPONENTS_product_common_popup_desktop_TravelInfoPopup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96434);
/* harmony import */ var _COMPONENTS_style_detailpackage_optiondetail__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43162);
/* harmony import */ var _COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17550);
/* harmony import */ var _QUERIES_bff_useEventTourDetail__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54804);
/* harmony import */ var _yb_ui_desktop_common_Noimage__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78860);












var TourDetailTemplateComponent = function(detail) {
    var trvInfoNm = detail.trvInfoNm, trvCd = detail.trvCd, locNm = detail.locNm, tempCd = detail.tempCd, trvInfoYn = detail.trvInfoYn, trvContent = detail.trvContent, refeNote = detail.refeNote, optCost = detail.optCost, useTm = detail.useTm, trvInfoId = detail.trvInfoId;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_hooks_common_useOverlay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(), 1), open = ref[0];
    var openMore = function(e) {
        e.preventDefault();
        open(function(props) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_product_common_popup_desktop_TravelInfoPopup__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
                trv: detail
            }));
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .TemplateItem */ .cU, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .Title */ .Dx, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                        children: trvInfoNm && "".concat(trvCd === "70" ? "[선택관광] " : "", " ").concat(trvInfoNm, " ").concat(locNm ? "(".concat(locNm, ")") : "")
                    }),
                    trvInfoId && trvCd !== "10" && trvInfoNm && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "#",
                        onClick: openMore,
                        children: "더보기"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .ThumbnailList */ .Rg, {
                grid: Number(tempCd) === 4 ? 1 : Number(tempCd),
                children: Array.from({
                    length: Number(tempCd) === 4 ? 1 : Number(tempCd)
                }, function(_, i) {
                    var url = "image".concat(i + 1, "Url");
                    var urlNm = "imageNm".concat(i + 1);
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .ThumbnailItem */ .l, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_yb_ui_desktop_common_Noimage__WEBPACK_IMPORTED_MODULE_11__/* .Noimage */ .T, {
                                width: "100%",
                                height: "auto",
                                src: detail[url] || "",
                                alt: "상품 이미지"
                            }),
                            detail[urlNm] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("em", {
                                children: detail[urlNm]
                            })
                        ]
                    }, "thumb".concat(i));
                })
            }),
            trvInfoYn === "Y" && trvContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, {
                dangerouslySetInnerHTML: {
                    __html: trvContent
                }
            }),
            refeNote && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .Notice */ .qX, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                        children: "참고하세요"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .NoticeText */ .hh, {
                        dangerouslySetInnerHTML: {
                            __html: refeNote
                        }
                    })
                ]
            }),
            (optCost || useTm) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .InfoBox */ .vD, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .InfoList */ .Q4, {
                    children: [
                        optCost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .InfoTitle */ .Xw, {
                                    children: "비용"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .InfoContent */ .aq, {
                                    children: optCost
                                })
                            ]
                        }),
                        useTm && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .InfoTitle */ .Xw, {
                                    children: "소요시간"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .InfoContent */ .aq, {
                                    children: useTm
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/**
 * 탬플릿
 * 숙소 | 관광지 | 즐길거리 | 먹거리 | 일차별 일정
 */ var TourDetailTemplate = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        logMsg: "TemplateTabs TourDetailTemplate Error",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TourDetailTemplateComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props))
    });
};
var AccommodationComponent = function(param) {
    var evCd = param.evCd;
    var useEventTourDtl = (0,_QUERIES_bff_useEventTourDetail__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(evCd);
    var accomm = useEventTourDtl.data.accommodation;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_optiondetail__WEBPACK_IMPORTED_MODULE_5__/* .TabContent */ .I5, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_optiondetail__WEBPACK_IMPORTED_MODULE_5__/* .ContentTitle */ .wW, {
                    children: accomm.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .TemplateList */ .HP, {
                    children: accomm.data.map(function(item, index) {
                        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(TourDetailTemplate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, item), {
                            key: index
                        }));
                    })
                })
            ]
        })
    });
};
/**
 * 숙소
 */ var Accommodation = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        logMsg: "TemplateTabs Accommodation Error",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AccommodationComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props))
    });
};
var TourlistDesinationComponent = function(param) {
    var evCd = param.evCd;
    var useEventTourDtl = (0,_QUERIES_bff_useEventTourDetail__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(evCd);
    var tourlistdest = useEventTourDtl.data.tourSpot;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_optiondetail__WEBPACK_IMPORTED_MODULE_5__/* .TabContent */ .I5, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_optiondetail__WEBPACK_IMPORTED_MODULE_5__/* .ContentTitle */ .wW, {
                    children: tourlistdest.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .TemplateList */ .HP, {
                    children: tourlistdest.data.map(function(item, index) {
                        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(TourDetailTemplate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, item), {
                            key: index
                        }));
                    })
                })
            ]
        })
    });
};
/**
 * 관광지
 */ var TourlistDestination = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        logMsg: "TemplateTabs TourlistDestination Error",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TourlistDesinationComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props))
    });
};
var EnjoyComponent = function(param) {
    var evCd = param.evCd;
    var useEventTourDtl = (0,_QUERIES_bff_useEventTourDetail__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(evCd);
    var enjoy = useEventTourDtl.data.entertainment;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_optiondetail__WEBPACK_IMPORTED_MODULE_5__/* .TabContent */ .I5, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_optiondetail__WEBPACK_IMPORTED_MODULE_5__/* .ContentTitle */ .wW, {
                    children: enjoy.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .TemplateList */ .HP, {
                    children: enjoy.data.map(function(item, index) {
                        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(TourDetailTemplate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, item), {
                            key: index
                        }));
                    })
                })
            ]
        })
    });
};
/**
 * 즐길거리
 */ var Enjoy = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        logMsg: "TemplateTabs Enjoy Error",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EnjoyComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props))
    });
};
var FoodComponent = function(param) {
    var evCd = param.evCd;
    var useEventTourDtl = (0,_QUERIES_bff_useEventTourDetail__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(evCd);
    var food = useEventTourDtl.data.food;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_COMPONENTS_style_detailpackage_optiondetail__WEBPACK_IMPORTED_MODULE_5__/* .TabContent */ .I5, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_optiondetail__WEBPACK_IMPORTED_MODULE_5__/* .ContentTitle */ .wW, {
                    children: food.title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_style_detailpackage_itinerarytemplate__WEBPACK_IMPORTED_MODULE_2__/* .TemplateList */ .HP, {
                    children: food.data.map(function(item, index) {
                        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createElement)(TourDetailTemplate, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, item), {
                            key: index
                        }));
                    })
                })
            ]
        })
    });
};
/**
 * 먹거리
 */ var Food = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_COMPONENTS_common_error_ErrorBoundary__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        logMsg: "TemplateTabs Food Error",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FoodComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props))
    });
};



/***/ })

}]);